import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import PaymentPage from "../screens/Payment/PaymentPage";
import PaymentDetails from "../screens/Payment/PaymentDetails";

const Stack = createStackNavigator();

const PaymentStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Payment" component={PaymentPage} />
      <Stack.Screen name="PaymentDetails" component={PaymentDetails} />
    </Stack.Navigator>
  );
};

export default PaymentStackNavigator;
